module.exports = __webpack_public_path__ + "assets/logo-biocodex.530583ed.svg";